import { useCallback } from "react";
import { useLocale } from "use-intl";

import { formatReleaseDate } from "@/lib/format-date";

/**
 * Returns a locale-aware `formatReleaseDate` bound to the current user locale.
 */
export function useFormatDate() {
  const locale = useLocale();
  return useCallback(
    (date: string | null | undefined) => formatReleaseDate(date, locale),
    [locale],
  );
}
